import React, { useState } from 'react';

interface UserProfileProps {
    name: string;
    email: string;
    bio: string;
}

const UserProfile: React.FC = () => {
    const [userProfile, setUserProfile] = useState<UserProfileProps>({
        name: 'John Doe',
        email: 'john.doe@example.com',
        bio: 'Software developer with a passion for trading.',
    });

    return (
        <div className='mt-2' style={{ padding: '0px 20px', maxWidth: '600px', margin: '0 auto' }}>
            <h2 className='titleColor'>User Profile</h2>
            <div style={{ marginBottom: '20px' }}>
                <strong>Name:</strong> <span>{userProfile.name}</span>
            </div>
            <div style={{ marginBottom: '20px' }}>
                <strong>Email:</strong> <span>{userProfile.email}</span>
            </div>
            <div style={{ marginBottom: '20px' }}>
                <strong>Bio:</strong> <p>{userProfile.bio}</p>
            </div>
        </div>
    );
};

export default UserProfile;
